import { render, staticRenderFns } from "./VariantsFormEl.vue?vue&type=template&id=0197e4ba&scoped=true&"
import script from "./VariantsFormEl.vue?vue&type=script&lang=js&"
export * from "./VariantsFormEl.vue?vue&type=script&lang=js&"
import style0 from "./VariantsFormEl.vue?vue&type=style&index=0&id=0197e4ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0197e4ba",
  null
  
)

export default component.exports